<template>
  <div class="basic-time-input-container">
    <!-- Time label -->
    <Field
      v-slot="{ field }"
      v-model="mutatedValue"
      :label="label"
      :name="name"
      :rules="validation"
    >
      <div class="form-element-container">
        <label
          :for="name"
          class="bordered-bottom"
        >{{ label }}</label>

        <!-- Time Picker -->
        <input
          :ref="name"
          type="time"
          class="bordered-bottom"
          v-bind="field"
          :min="min"
          :max="max"
          :placeholder="placeholder"
          @input="onInput"
        >
      </div>
      <ErrorMessage
        class="error-msg"
        :name="name"
      />
    </Field>
  </div>
</template>

<script>
import { Field, ErrorMessage } from 'vee-validate'
/**
 * Props:
 * name: input name (string)
 * label: Title displayed: e.g.:'Selectionner une option: ' (string)
 * valueDate: the date that'll need to be displayed on loading e.g.: 2018-07-15 (string)
 */
export default {
  name: 'BasicTimeInput',
  components: { Field, ErrorMessage },
  props: {
    label: String,
    placeholder: String,
    validation: [String, Boolean],
    defaultValue: [String, Array],
    name: String,
    min: String,
    max: String
  },
  emits: ['addData'],
  data() {
    return {
      mutatedValue: this.defaultValue
    }
  },
  mounted() {
    this.mutatedValue
      ? this.$emit('addData', { value: this.mutatedValue, name: this.name })
      : this.$emit('addData', { value: '', name: this.name })
  },
  methods: {
    onInput({ target }) {
      this.$emit('addData', { value: target.value, name: this.name })
    }
  }
}
</script>

<style lang="scss" scoped>
  .basic-time-input-container {
    display: flex;
    justify-content: flex-start;
    margin: 10px 0;

    /* Tablet (portrait) */
    @media only screen and (width >= 768px) {
      margin: 20px 0;
    }

    /* Desktops and laptops */
    @media only screen and (width >= 1024px) {
      margin: 20px 0;
    }

    /* Large screens */
    @media only screen and (width >= 1824px) {
      margin: 20px 0;
    }

    .form-element-container {
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
      width: 100%;

      label,
      input {
        width: 50%;
      }
    }
  }

  input::-webkit-clear-button {
    appearance: none;
    height: 1rem;
    width: 1rem;
    background-image: url('@/assets/icons/close.png');
    background-position: center right;
    background-origin: content-box;
    background-repeat: no-repeat;
    background-size: contain;
  }
</style>
